<template>
  <v-dialog v-model="dialog" max-width="1000px">
    <v-text-field
      slot="activator"
      :label="label"
      :value="value.name"
      :rules="rules"
      append-icon="arrow_drop_down"
      readonly
    ></v-text-field>
    <v-card>
      <v-card-title>选择职业类别</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="category-menu">
        <v-list class="categore-list">
          <v-list-tile
            v-for="(item,index) in categories"
            :key="item.id"
            href="javascript:;"
            @mouseenter="categoryIndex = index"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action class="categore-list-item-action">
              <v-btn icon>
                <v-icon>chevron_right</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>

        <v-divider v-show="categories2.length>0" vertical class="mx-2"></v-divider>

        <v-list v-if="categories2.length>0" class="categore-list">
          <v-list-tile
            v-for="(item,index) in categories2"
            :key="item.id"
            href="javascript:;"
            @mouseenter="categoryIndex2 = index"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action class="categore-list-item-action">
              <v-btn icon>
                <v-icon>chevron_right</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>

        <v-divider v-show="categories3.length>0" vertical class="mx-2"></v-divider>

        <v-list v-if="categories3.length>0" class="categore-list">
          <v-list-tile
            v-for="item in categories3"
            :key="item.id"
            :disabled="limit && !item.isCover"
            @click="onSelected(item)"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default() {
        return {
          name: ""
        };
      }
    },
    // form input 校验规则
    rules: {
      type: Array,
      default() {
        return [];
      }
    },
    label: {
      type: String,
      default: ""
    },
    // 职业类别限制到几级
    limit: Number,
    comId:{
      type:String,
      default:'1001'
    }
  },
  data() {
    return {
      dialog: false,
      categoryIndex: -1,
      categoryIndex2: -1,
      disabledCodes: [
        "0701008",
        "0701009",
        "0701010",
        "0701011",
        "0701012",
        "0701013",
        "0701014",
        "0701015",
        "0701016",
        "0701017",
        "0701019",
        "0701020",
        "0701021",
        "0701022",
        "0701023",
        "0701024",
        "0701025",
        "0701027",
        "0701028",
        "0701029",
        "0701030",
        "0701032",
        "0701034",
        "0701035",
        "0701036",
        "0701037",
        "0701038",
        "0705008",
        "0706002",
        "0816007",
        "1401010",
        "1603017"
      ]
    };
  },
  computed: {
    categories() {
      return this.$store.state.insure.categories;
    },
    categories2() {
      if (
        this.categoryIndex > -1 &&
        this.categoryIndex < this.categories.length
      ) {
        return this.categories[this.categoryIndex].children;
      }
      return [];
    },
    categories3() {
      if (
        this.categoryIndex2 > -1 &&
        this.categoryIndex2 < this.categories2.length
      ) {
        const categories3 = this.categories2[this.categoryIndex2].children;
        return categories3;
      }
      return [];
    }
  },
  mounted() {
    this.$store.dispatch("getCategories",this.comId);
  },
  methods: {
    onSelected(val) {
      if (this.limit && val.level > this.limit) {
        return false;
      }
      this.$emit("input", val);
      this.dialog = false;
      // this.$emit("selected", this.index, val);
    }
  }
};
</script>

<style lang="scss">
.category-menu {
  display: flex;
  top: 250px !important;
  .categore-list {
    height: 300px;
    width: 300px;
    overflow-x: auto;
    overflow-y: auto;
    .categore-list-item-action {
      min-width: 26px;
    }
  }
}
</style>

